import type { AxiosErrorObject } from '@qse/constants'
/**
 * An error originating from the API
 */
export class ApiError extends Error {
  public readonly name = 'ApiError'
  public readonly statusCode: number
  public readonly config: any
  public readonly response: any

  constructor(error: any) {
    const { message, statusCode } = ApiError.processErrorObject(error)

    super(message || 'An error occurred')
    this.statusCode = statusCode
    this.config = error.config || {}
    this.response = error.response || {}
    Object.setPrototypeOf(this, new.target.prototype)
  }

  // 👇 ensure toast shows only the message
  override toString(): string {
    return this.message
  }

  private static processErrorObject(error: AxiosErrorObject): {
    message: string
    statusCode: number
  } {
    const axiosError =
      error?.response?.data?.error ?? error?.response?.data ?? error?.response ?? error

    const message =
      axiosError?.message ??
      axiosError?.error_description ?? // common alt field
      axiosError?.error ?? // some APIs
      'An error occurred'

    const statusCode = axiosError?.status ?? axiosError?.statusCode ?? 500

    return { message, statusCode }
  }
}

/**
 * An unknown error type
 */
export class UnknownError extends Error {
  public readonly name = 'UnknownError'

  constructor(error: any) {
    super(error.message || 'An unknown error occurred')
    Object.setPrototypeOf(this, new.target.prototype)
  }

  override toString(): string {
    return this.message
  }
}
